// extracted by mini-css-extract-plugin
module.exports = {"melodyCardCategory":"Pg-z","categoryName":"Qg-z","categoryImage":"Rg-z","categoryContent":"Sg-z","bottomAligned":"Tg-z"};